var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "duhjz5luma",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zs3uzqvaeb",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#duhjz5luma)",
    d: "M.61 6.544c-.368.147-.61.504-.61.9v7.586c0 .343.346.577.665.45l4.183-1.904V6.513c-.267-.485-.486-.956-.643-1.407L.61 6.544zm8.117 4.355c-.426 0-.83-.187-1.106-.514-.596-.703-1.23-1.503-1.803-2.325v5.515l5.818 1.94V8.06c-.573.82-1.206 1.621-1.802 2.324-.277.327-.68.514-1.107.514zm8.063-6.015l-4.184 1.904v8.727l4.239-1.695c.368-.147.61-.504.61-.9V5.333c0-.343-.347-.578-.665-.45z",
    transform: "translate(-314 -21) translate(302 16) translate(12 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zs3uzqvaeb)",
    d: "M8.727 0C6.618 0 4.91 1.71 4.91 3.818c0 1.705 2.496 4.812 3.452 5.94.193.229.54.229.733 0 .956-1.128 3.451-4.235 3.451-5.94C12.545 1.71 10.836 0 8.727 0z",
    transform: "translate(-314 -21) translate(302 16) translate(12 5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMap);
export default __webpack_public_path__ + "static/media/ic-map.23da0984.svg";
export { ForwardRef as ReactComponent };